/**
 *
 * @module storage
 *
 */

import Util from './../../util/entry';
import Logging from './../../../logging/entry';
import CoreStorageProvider from './../shared/coreStorageProvider';
import MemoryStore from './../memoryStore';

/**
 *
 * @class Storage
 * @extends {CoreStorageProvider}
 * @desc Isomorphic Storage provider implementation. Based on localStorage for browser and Node.
 *
 * @example
 * const storage = new Storage(logger);
 *
 */
export default class Storage extends CoreStorageProvider {

    /**
     *
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(logger = Logging) {

        const scope = Util.getScope();
        const hasLocalStorage = typeof scope.localStorage !== 'undefined' && scope.localStorage !== null;
        const storeMessage = hasLocalStorage ? 'Using native localStorage.' : 'Using MemoryStore instance.';

        super(logger);

        /**
         *
         * @access private
         * @type {Object}
         * @desc storage reference, uses the global local storage
         * instance (if available), falls back to a plain Object implementation
         *
         */
        this.store = hasLocalStorage ? scope.localStorage : new MemoryStore();

        this.logger.log('Storage', 'Created Isomorphic Provider.');
        this.logger.info('Storage', storeMessage);

    }

}



// WEBPACK FOOTER //
// ./src/services/platforms/isomorphic/storage.js